module.exports = __webpack_public_path__ + "media/images/doordash-71f37057502d2431ab5ed2f994f89ef3.svg";